import * as go from 'gojs';

export const scale = () =>
  new go.Binding('scale', '', (data) => {
    return data?.attachmentTool?.enabled ? 0.8 : 1;
  });

export const alignment = () =>
  new go.Binding('alignment', '', (data) => {
    return data?.attachmentTool?.enabled ? go.Spot.BottomLeft : go.Spot.Center;
  });

export const alignmentFocus = () =>
  new go.Binding('alignmentFocus', '', (data) => {
    return data?.attachmentTool?.enabled ? new go.Spot(0, 1.1) : go.Spot.Center;
  });

export const attachmentToolBindings = [scale, alignment, alignmentFocus];
